import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HealthApiModels } from 'models/api/health-api.models';
import { TableModels } from 'models/table.models';
import { ConfigurationModels } from '../../../../../../models/configuration.models';
import { ApiServiceBase } from '../api-service-base';

@Injectable({
  providedIn: 'root',
})
export class HealthAdminApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'health/healthadmin');
  }

  postSendDirectDebitFile(file: File) {
    return this.postFormData<HealthApiModels.DirectDebitFileTableRow>(
      '/uploadDirectDebitFile',
      {
        directDebitFile: file,
      },
    );
  }

  getDirectDebitFiles(request: TableModels.PaginatedRequest) {
    return this.getJson<
      TableModels.PaginatedResult<HealthApiModels.DirectDebitFileTableRow>
    >('/directDebitFiles', {
      ...request,
    });
  }

  getRejectFiles(request: TableModels.PaginatedRequest) {
    return this.getJson<
      TableModels.PaginatedResult<HealthApiModels.RejectFileTableRow>
    >('/rejectFiles', {
      ...request,
    });
  }

  postMarkRejectAsDone(rejectId: number) {
    return this.post<HealthApiModels.RejectFileTableRow>(
      `/rejectFiles/markAsDone/${rejectId}`,
      {},
    );
  }
}
